import React from 'react'
import { NavLink, Outlet } from 'react-router-dom'

const OrganizationsList = () => {
    return (
        <div className='page-container'>
            <div className="page-body multi-content-page">
                <div className="page-side-menu">
                    <div className="menu-items-list">
                        <div className='page-menu-item'>
                            <NavLink to={`/organizations/`}>All</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/organizations/member`}>Member</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/organizations/friend`}>Friend</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/organizations/admin`}>Admin</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/organizations/following`}>Following</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/organizations/created`}>Created</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/organizations/suggested`}>Suggested</NavLink>
                        </div>

                    </div>
                </div>
                <div className="page-content">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default OrganizationsList